import React from 'react';

import Add from 'components/Icons/Add';
import Change from 'components/Icons/Change';
import Close from 'components/Icons/Close';
import Delete from 'components/Icons/Delete';
import Download from 'components/Icons/Download';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const TaskButton: React.FC<ComponentProps> = ({
  disabled,
  children,
  iconType,
  styleType,
  onClick = () => {},
  ...rest
}) => {
  const IconWrapper = (
    <Styled.TaskButtonIconWrapper disabled={disabled}>
      {iconType === 'add' && <Add className={iconType} />}
      {iconType === 'change' && <Change className={iconType} />}
      {iconType === 'delete' && <Delete className={iconType} />}
      {iconType === 'download' && <Download className={iconType} />}
      {iconType === 'cancel' && <Close className={iconType} />}
    </Styled.TaskButtonIconWrapper>
  );

  return (
    <Styled.TaskButtonWrapper
      disabled={disabled}
      iconType={iconType}
      styleType={styleType}
      onClick={onClick}
      {...rest}>
      {iconType && IconWrapper}
      <Styled.TextWrapper disabled={disabled} iconType={iconType}>
        {children}
      </Styled.TextWrapper>
    </Styled.TaskButtonWrapper>
  );
};

export default TaskButton;
